import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcFaultFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 53,
	height: 52,
	viewBox: "0 0 53 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.9218 10.5H8.5C6.29086 10.5 4.5 12.2909 4.5 14.5V38.4298C4.5 40.639 6.29086 42.4298 8.5 42.4298H40.0789C42.2881 42.4298 44.0789 40.639 44.0789 38.4298V17.4801C44.0789 15.271 42.2881 13.4801 40.079 13.4801H18.0317C16.8384 13.4801 15.7115 12.9305 14.9768 11.9901C14.2421 11.0496 13.1152 10.5 11.9218 10.5Z",
		fill: "#DFE3EA"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.5761 22.272L7.26254 37.079C6.32737 39.685 8.25877 42.4301 11.0275 42.4301H41.1565C42.8226 42.4301 44.3143 41.3973 44.9006 39.8377L50.4672 25.0306C51.4505 22.4151 49.5173 19.623 46.7231 19.623H16.341C14.6528 19.623 13.1464 20.683 12.5761 22.272Z",
		fill: "#EDF0F4"
	})]
});
export default SvgIcFaultFolder;
